export const MOBILE_LABELS = {
  oneway: 'Local de retirada e devolução',
  pickup: 'Local de retirada',
  dropoff: 'Local de devolução',
};
